import { render, staticRenderFns } from "./VideoPlay.vue?vue&type=template&id=f93cc346&scoped=true"
import script from "./VideoPlay.vue?vue&type=script&lang=js"
export * from "./VideoPlay.vue?vue&type=script&lang=js"
import style0 from "./VideoPlay.vue?vue&type=style&index=0&id=f93cc346&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93cc346",
  null
  
)

export default component.exports